import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { Badge, BadgeSize } from '../../../../Badge'
import { ICON_COLOR, ICON_HEIGHT_16, IconNG } from '../../../../Icon'
import Text from '../../../../Text'
import { checkIsPhaseStripItemDone } from '../../RentalPortalPhaseBar.utils'

import * as styles from './PhaseStripItem.module.css'

import CheckmarkIcon from '../../../../../icons/checkmark.svg'

function PhaseStripItem({ children, isNeedsYou, label, meta, state }) {
  const { t } = useTranslation()

  const isDone = checkIsPhaseStripItemDone(state)

  return (
    <div className={styles.PhaseStripItem}>
      <span
        className={classNames(styles.marker, {
          [styles.markerDone]: isDone,
          [styles.markerNeedsYou]: isNeedsYou,
        })}
      >
        {isDone ? (
          <IconNG
            Icon={CheckmarkIcon}
            color={ICON_COLOR.CurrentColor}
            size={ICON_HEIGHT_16}
          />
        ) : null}
      </span>
      <div
        className={classNames(styles.content, {
          [styles.contentNeedsYou]: isNeedsYou,
        })}
      >
        <Text className={styles.label}>{label}</Text>
        {meta ? (
          <Text isSecondary className={styles.meta}>
            {meta}
          </Text>
        ) : null}
        {isNeedsYou ? (
          <span className={styles.needsYou}>
            <Badge className={styles.needsYouDot} size={BadgeSize.Medium} />
            {t('RentalPortal.PhaseStripNeedsYouKey')}
          </span>
        ) : null}
        {children}
      </div>
    </div>
  )
}

export default PhaseStripItem
